import { render, staticRenderFns } from "./NewStructuralElementForm.vue?vue&type=template&id=83cb8dbe&scoped=true&"
import script from "./NewStructuralElementForm.vue?vue&type=script&lang=js&"
export * from "./NewStructuralElementForm.vue?vue&type=script&lang=js&"
import style0 from "./NewStructuralElementForm.vue?vue&type=style&index=0&id=83cb8dbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cb8dbe",
  null
  
)

export default component.exports